import { useEffect } from "react"
import Popup from "../../../component/Popup"
import TrendImages from "./ImagesPopupUI"

const NewsFeedShareImagePopup = ({ imagePopupData, setImagePopupData }) => {
  useEffect(() => {
    console.log(imagePopupData)
  }, [imagePopupData])

  return imagePopupData ? <Popup
    setIsPopUp={() => {
      setImagePopupData(null)
    }}
    isPopUp={imagePopupData}>
    <TrendImages tag={imagePopupData.tag} value={imagePopupData.value} category={imagePopupData.category} gender={imagePopupData.gender} shareTag={imagePopupData.shareTag} shareValue={imagePopupData.shareValue} />

  </Popup> : null
}

export default NewsFeedShareImagePopup
